
class HitArea {

  constructor(model) {
    
    if (model.id) {
      this.id = model.id
    }

    this.target = function () {
      let target = model.target()

      // If a target is found, ensure to only return a facade.
      
      return target ? target.facade() : null
    }

    this.color = function (color) {
      model.color(color)
      return this
    }

    this.stroke = function (color, width = 1) {
      model.stroke(color, width)
      return this
    }

    this.data = function () {
      return model.toJSON()
    }
  }
}

export default HitArea
